export const parseDatabaseDate = (dbDate) => {
    let removeTimePart = dbDate.split("T")
    let [year, month, day] = removeTimePart[0].split("-").map(Number);
    return new Date(Date.UTC(year, month - 1, day)); // Mes -1 porque en JS enero = 0
}